import { render } from "./VoucherCreateComponent.vue?vue&type=template&id=cf834062"
import script from "./VoucherCreateComponent.vue?vue&type=script&lang=js"
export * from "./VoucherCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__